var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.501 2.5L19.4861 19.044C19.3738 19.3526 19.1693 19.6191 18.9003 19.8074C18.6312 19.9958 18.3108 20.0967 17.9824 20.0966H6.53182C6.22015 20.0971 5.91513 20.0065 5.65425 19.836C5.39336 19.6655 5.18797 19.4225 5.0633 19.1368L1.63356 9.53865C1.52712 9.29477 1.48319 9.0282 1.50577 8.76307C1.52834 8.49793 1.61669 8.24262 1.76282 8.02025C1.90895 7.79787 2.10825 7.61546 2.34266 7.48954C2.57707 7.36361 2.83918 7.29815 3.10527 7.29908H23.1009",
    stroke: "#00842F",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70366 23.6455C8.16001 23.6455 7.63862 23.8615 7.25419 24.2459C6.86977 24.6303 6.65381 25.1517 6.65381 25.6954C6.65381 26.1008 6.77403 26.4971 6.99927 26.8342C7.22451 27.1713 7.54466 27.434 7.91921 27.5892C8.29377 27.7443 8.70592 27.7849 9.10356 27.7058C9.50119 27.6267 9.86644 27.4315 10.1531 27.1448C10.4398 26.8581 10.635 26.4929 10.7141 26.0953C10.7932 25.6976 10.7526 25.2855 10.5975 24.9109C10.4423 24.5364 10.1796 24.2162 9.84249 23.991C9.50539 23.7657 9.10907 23.6455 8.70366 23.6455Z",
    fill: "#00842F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7019 23.6455C16.1583 23.6455 15.6369 23.8615 15.2525 24.2459C14.8681 24.6303 14.6521 25.1517 14.6521 25.6954C14.6521 26.1008 14.7723 26.4971 14.9976 26.8342C15.2228 27.1713 15.5429 27.434 15.9175 27.5892C16.2921 27.7443 16.7042 27.7849 17.1019 27.7058C17.4995 27.6267 17.8647 27.4315 18.1514 27.1448C18.4381 26.8581 18.6333 26.4929 18.7124 26.0953C18.7915 25.6976 18.7509 25.2855 18.5958 24.9109C18.4406 24.5364 18.1779 24.2162 17.8408 23.991C17.5037 23.7657 17.1074 23.6455 16.7019 23.6455Z",
    fill: "#00842F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.502de8b5.svg";
export { ForwardRef as ReactComponent };